import SelectDropdown from "../../../components/dropdown/selectdropdown/SelectDropdown"
import Heading from "../../../components/heading/Heading"
import { VEC_ICON_NAME } from "../../../components/icons/constants"
import { HEADING } from "../../../components/heading/constants/constants"
import styles from './PayerDropdown.styles'
import { useEffect, useState } from "react"
import { FILTER_OPTIONS, PAYER_DROPDOWN_LOADING_STATES, PAYER_DROPDOWN_MESSAGE_MAP } from "./constants"
import { getPaginatedPayersList } from "./PayerDropdownSaga"
import { componentKey, setPayersPaginationState, setSelectedPayer } from "./PayerDropdownSlice"
import { useDispatch, useSelector } from "react-redux"
import Loadable from "../../../components/loadable/Loadable"
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks"
import { QUERY_PARAMS } from "../../formssection/constants"
import useTxSearchParams from "../../../../libs/txsearchparams/TxSearchParamsHook"

export default function PayerDropdown({
    options = [],
    hideHeader = false,
    hideFilerOption = false,
    dropdownContainerStyles = {},
    containerStyles = {},

    selectPayerDropdownProps = {
        label: "",
        selectedValue: { label: '', value: '' },
        styles: {},
        onSearchInputChangeCb: () => { },
        onDropdownTouchedToBottomCb: () => { },
        clearSearchTextCb: () => { },
        onSelectCb: () => { },
    },
    disabled = false
}) {

    useGarbageCollector(componentKey);

    const [searchText, setSearchText] = useState("");
    const [filterOption, setFilterOption] = useState(FILTER_OPTIONS[0]);
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { payersList, payersPaginationState, selectedPayer, loadingState } = useSelector(state => state[componentKey])

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])

    useEffect(() => {
        if (!selectedPayer?.PayerDetailId) {
            dispatch(getPaginatedPayersList({ ...payersPaginationState, defaultPayer: selectPayerDropdownProps?.selectedValue, selectedPayer: selectedPayer }))
        }
    }, [])

    useEffect(() => {
        if (searchText != "") {
            const timer = setTimeout(() => {

                dispatch(setPayersPaginationState({ ...payersPaginationState, ...(filterOption.value == "NAME" ? { FilterText: searchText } : { IdNumber: searchText }) }))

                if (!payersList?.length) {
                    dispatch(getPaginatedPayersList({ ...payersPaginationState, PageNumber: 1, ...(filterOption.value == "NAME" ? { FilterText: searchText } : { IdNumber: searchText }), selectedPayer: selectedPayer }))
                }

            }, 500);

            return () => {
                clearTimeout(timer);
            };
        }

    }, [searchText]);

    useEffect(() => {
        if (selectPayerDropdownProps?.onSelectCb) {
            selectPayerDropdownProps.onSelectCb(selectedPayer)
        }
    }, [selectedPayer])

    const onSelectCbHandler = (name, selectedOption) => {
        dispatch(setSelectedPayer(selectedOption));
        queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.PayerDetailId);
        setQueryParams(queryParams);
    }


    return (
        <Loadable currentState={loadingState.state} loadingStates={[PAYER_DROPDOWN_LOADING_STATES.GET_PAGINATED_PAYER_LIST_LOADING]} messageMap={PAYER_DROPDOWN_MESSAGE_MAP} isNewLoadable={true}>
            <div style={{ ...styles.container, ...containerStyles }}>

                {!hideHeader && <div>
                    <Heading type={HEADING.H1}>Please select a payer</Heading>
                </div>}

                <div style={{ ...styles.selectGroupContainer, ...dropdownContainerStyles }}>

                    {!hideFilerOption && <SelectDropdown
                        value={filterOption}
                        onSelectCb={(name, selectedOption) => setFilterOption(selectedOption)}
                        options={FILTER_OPTIONS}
                        disabled={disabled}
                        isClearable={false}
                    />}

                    <SelectDropdown
                        label={selectPayerDropdownProps?.label}
                        name="selectPayer"
                        customInputStyles={selectPayerDropdownProps.styles ? { ...selectPayerDropdownProps.styles } : {}}
                        placeHolder={filterOption?.value == "NAME" ? "Enter payers name" : "Enter payers tax id"}
                        suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                        value={selectedPayer}
                        onSelectCb={onSelectCbHandler}
                        options={paginatedPayerList.slice(0, payersPaginationState.PageSize * (payersPaginationState.PageNumber))}
                        onSearchInputChangeCb={(e) => {
                            const filteredOptions = payersList.filter(opt => opt[filterOption?.value == "NAME" ? "Name" : "IdNumber"].toLowerCase().includes(e.target.value.toLowerCase()))
                            setPaginatedPayerList(filteredOptions)
                            dispatch(setPayersPaginationState({ PageNumber: 1 }))
                            setSearchText(e.target.value)
                        }}
                        onDropdownTouchedToBottomCb={() => {
                            if (payersPaginationState.PageSize * (payersPaginationState.PageNumber) < paginatedPayerList?.length) {
                                dispatch(setPayersPaginationState({ PageNumber: payersPaginationState.PageNumber + 1 }))
                            }
                        }}
                        clearSearchTextCb={() => {
                            setPaginatedPayerList(payersList)
                        }}
                        searchInitials={false}
                    />
                </div>
            </div>
        </Loadable>
    )
}